import { ErrorContentModel } from '../models/ErrorContentModel.interface';
import { ModuleUrl } from './modules-urls.enum';

// 1. Definimos constantes para URLs que se repiten mucho
const URL_CUENTA_DIGITAL = 'https://www.bci.cl/pyme/cuenta-digital-pyme';
const URL_HOME_PYME = 'https://www.bci.cl/pyme';

// 2. Helper para errores comunes de "No eres apoderado/cliente" (PER0001, EXGCC0024, CCPE4)
const createNoClientError = (title: string): ErrorContentModel => ({
  action: 'PAGE',
  asset: 'assets/images/cuenta.svg',
  title,
  description: 'Te invitamos a abrir tu Cuenta Corriente Digital Bci Pyme.',
  buttons: {
    primary: {
      description: 'Abrir cuenta digital',
      action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
    },
  }
});

// 3. Helper para errores de Email (EXDC0003, EXCCC0002, EXCCC0006)
const createEmailError = (title: string, navAction: any): ErrorContentModel => ({
  action: 'PAGE',
  asset: 'assets/images/correo.svg',
  title,
  description: 'Llámanos al 226928555 o escribe a apoyoempresarios@bci.cl para crear tu Clave de internet y activar tu cuenta.',
  buttons: {
    primary: {
      description: 'Entendido',
      action: navAction
    },
  }
});

export const content: { [key: string]: ErrorContentModel } = {
  'CLAVE-CREADA': {
    action: 'MODAL',
    asset: 'assets/images/cuenta.svg',
    title: 'Ya tienes una clave de cliente Bci PYME',
    description: 'Si no la recuerdas modifícala con tu Multipass, si no lo tienes solicítalo en una de nuestras sucursales.',
    buttons: {
      primary: {
        description: 'Modificar clave',
        action: ['NAVIGATE_OUT', 'https://www.bci.cl/pyme/desbloquear-clave']
      },
      secondary: {
        description: 'Conocer mi sucursal',
        action: ['NAVIGATE_OUT', 'https://www.bci.cl/corporativo/sucursales-y-cajeros']
      }
    }
  },
  'CLAVE-DIGITAL': {
    action: 'PAGE',
    asset: 'assets/images/password.svg',
    title: 'Ya tienes una Clave internet creada',
    description: 'Si tienes problemas con tu clave o la has olvidado, crea una nueva en Banco en Línea para ingresar a tu cuenta en Bci Pyme.',
    buttons: {
      primary: {
        description: 'Ir a Banco en Línea',
        action: ['NAVIGATE_OUT', 'https://www.bci.cl/pyme/desbloquear-clave']
      },
      secondary: {
        description: 'Salir',
        action: ['NAVIGATE_OUT', URL_HOME_PYME]
      }
    }
  },
  'CLAVE-TRAD': {
    action: 'PAGE',
    asset: 'assets/images/password.svg',
    title: 'Ya tienes una Clave internet creada',
    description: 'Si tienes problemas con tu clave o la has olvidado, crea una nueva en Banco en Línea para ingresar a tu cuenta en Bci Pyme.',
    buttons: {
      primary: {
        description: 'Ir a Banco en Línea',
        action: ['NAVIGATE_OUT', 'https://www.bci.cl/pyme/crear-clave']
      },
      secondary: {
        description: 'Salir',
        action: ['NAVIGATE_OUT', URL_HOME_PYME]
      }
    }
  },
  'CLAVE-CREADA-CLIENTE': {
    action: 'MODAL',
    asset: 'assets/images/cuenta.svg',
    title: 'Eres cliente de Bci Pyme',
    description: 'Elige si quieres mantener tu clave actual o crear una nueva para ingresar a tu Banco en Línea.',
    buttons: {
      primary: {
        description: 'Mantener mi clave',
        action: ['NAVIGATE_IN', ModuleUrl.SUCCESS]
      },
      secondary: {
        description: 'Crear Clave de internet',
        action: ['NAVIGATE_IN', ModuleUrl.CODE_VALIDATION]
      }
    }
  },
  'CLAVE-CREADA-RESETEO': {
    action: 'MODAL',
    asset: 'assets/images/cuenta.svg',
    title: 'Eres cliente Pyme y ya tienes tu Clave de Internet',
    description: 'Tu Clave es única para todas tus cuentas Pyme. Si la cambias, ten en cuenta que se actualizará en todas las cuentas asociadas a tu RUT.',
    buttons: {
      primary: {
        description: 'Mantener mi clave e ingresar',
        action: ['NAVIGATE_OUT', URL_HOME_PYME]
      },
      secondary: {
        description: 'Cambiar Clave de Internet',
        action: ['NAVIGATE_IN', ModuleUrl.CODE_VALIDATION]
      }
    }
  },

  // Agrupación de errores de cliente (Solución Duplicados Sonar)
  'PER0001': createNoClientError('No eres Apoderado Autorizado Pyme'),
  'EXGCC0024': createNoClientError('No eres Apoderado Pyme'),
  'CCPE4': createNoClientError('No eres cliente BCI'),

  // Agrupación de errores de email
  'EXDC0003': createEmailError('Actualiza tu email para validar tu identidad', ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]),
  'EXCCC0006': createEmailError('Email no existente para validar tu identidad', ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]),
  'EXCCC0002': createEmailError('Actualiza tu email para validar tu identidad', ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]),

  'EXICI0001': {
    action: 'PAGE',
    asset: 'assets/images/sello-identidad.svg',
    title: 'Tu cédula de identidad está vencida',
    description: 'Contacta al Registro Civil para renovar tu cédula y poder continuar con la creación de tu Clave de internet.',
    buttons: {
      primary: {
        description: 'Volver al inicio',
        action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
      },
    }
  },
  'EXICI0002': {
    action: 'PAGE',
    asset: 'assets/images/sello-identidad.svg',
    title: 'Tu cédula de identidad fue bloqueada',
    description: 'Para desbloquear tu cédula de identidad, comunícate con el Registro Civil. Una vez resuelto el bloqueo, podrás continuar con tu solicitud.',
    buttons: {
      primary: {
        description: 'Volver al inicio',
        action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
      },
    }
  },
  'EXICI0003': {
    action: 'PAGE',
    asset: 'assets/images/sello-identidad.svg',
    title: 'Verificación de documento necesaria',
    description: 'Para seguir con la creación de tu clave de internet, confirma que el número de documento sea el correcto.',
    buttons: {
      primary: {
        description: 'Entendido',
        action: ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]
      },
    }
  },
  'EXICI0004': {
    action: 'MODAL',
    asset: 'assets/images/sello-identidad.svg',
    title: 'Verifica tu RUT',
    description: ' El RUT no coincide con el registrado. Ingresa el RUT correcto para continuar con la creación de tu clave de internet.',
    buttons: {
      primary: {
        description: 'Ingresar RUT',
        action: ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]
      },
    }
  },
  'UNESPECTED':{
    action: 'PAGE',
    asset: 'assets/images/bancoerror.svg',
    title: 'Ocurrió un problema',
    description: 'Lo sentimos, ha ocurrido un error inesperado. Si tienes dudas, llámanos al 600 692 8000.',
    buttons: {
      primary: {
        description: 'Salir',
        action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
      }
    }
  },
  'NOCONNECTION': {
    action: 'MODAL',
    asset: 'data:image/svg+xml;base64,...', // (Mantener tu Base64 aquí)
    title: 'Sin conexión a internet',
    description: 'Intenta continuar con tu apertura de cuenta cuando vuelvas a tener conexión.',
    buttons: { primary: { description: 'Entendido', action: null } }
  },
  'INTERNAL_SERVER_ERROR': {
    action: 'MODAL',
    asset: 'assets/images/banco.svg',
    title: 'Problema al crear tu clave',
    description: 'Presentamos intermitencia en el servicio. Intenta crear tu clave de nuevo.',
    buttons: {
      primary: {
        description: 'Reintentar',
        action: ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]
      },
      secondary: {
        description: 'Continuar en otro momento',
        action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
      }
    }
  },
  'EXPIRED_TOKEN':  {
    action: 'PAGE',
    asset: 'assets/images/banco.svg',
    title: 'Tu sesion ha caducado',
    description: 'Has superado el tiempo límite para realizar esta operación. Te invitamos a reiniciar tu solicitud.',
    buttons: {
      primary: {
        description: 'Reiniciar solicitud',
        action: ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]
      },
      secondary: {
        description: 'Continuar en otro momento',
        action: ['NAVIGATE_OUT', URL_CUENTA_DIGITAL]
      }
    }
  },
  'PASSWORD_NOT_CREATED':  {
    action: 'PAGE',
    asset: 'assets/images/alerta-amarilla.svg',
    title: 'Problema al crear tu clave',
    description: ' Intenta crear tu clave de nuevo. Si tienes dudas, llámanos al 22692 8555.',
    buttons: {
      primary: {
        description: 'Entendido',
        action: ['NAVIGATE_IN', ModuleUrl.RUT_VALIDATION]
      }
    }
  }
}